import { ModalStyle as Modal, FormikField, Button } from "@hubrise/react-components"
import type { InputRef } from "@hubrise/react-components"
import { Form, Formik } from "formik"
import type { FormikErrors } from "formik"
import * as React from "react"
import { useTranslation } from "react-i18next"

interface ModalContentProps {
  onClose: () => void
  inputPlaceholder?: string
  handleCreate: (name: string) => void
  title: string
}

type FormValues = { name: string }

const ModalContent = ({ onClose, inputPlaceholder, handleCreate, title }: ModalContentProps): JSX.Element => {
  const { t } = useTranslation()

  const $nameRef = React.useRef<InputRef>(null)

  React.useEffect(() => {
    if ($nameRef.current) $nameRef.current.focus()
  })

  const doCreate = ({ name }: FormValues): void => {
    handleCreate(name)
    onClose()
  }

  const validate = (values: FormValues): FormikErrors<FormValues> => {
    const errors: FormikErrors<FormValues> = {}
    if (values.name.length === 0) errors.name = t("validations.not_empty")
    return errors
  }

  const initialValues: FormValues = { name: "" }

  return (
    <Formik initialValues={initialValues} onSubmit={doCreate} validate={validate}>
      <Form>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
          <Modal.Close onClick={onClose} />
        </Modal.Header>

        <Modal.Body>
          <FormikField.Input
            ref={$nameRef}
            name="name"
            label={t("general.name")}
            withMargin
            placeholder={inputPlaceholder}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" type="submit">
            {t("general.create")}
          </Button>
          <Button variant="empty" onClick={onClose}>
            {t("general.cancel")}
          </Button>
        </Modal.Footer>
      </Form>
    </Formik>
  )
}

export default ModalContent
